<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card no-body>
        <b-card-body>
          <b-overlay :show="loading" rounded="md" variant="transparent">
            <validation-observer ref="detailDepartmentValidate">
              <b-form ref="detailDepartmentFormElement">
                <b-row>
                  <b-col sm="12">
                    <b-form-group label-for="name" :label="t('Name')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Name')"
                        rules="required|alpha_spaces"
                      >
                        <b-form-input
                          id="name"
                          v-model="values.name"
                          name="name"
                          type="text"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Name')"
                          :tabindex="1"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group
                      label-for="authorized_person_name"
                      :label="t('Authorized Person Name')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Authorized Person Name')"
                        rules="required|alpha_spaces"
                      >
                        <b-form-input
                          id="authorizedPersonName"
                          v-model="values.authorized_person_name"
                          name="authorized_person_name"
                          type="text"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Authorized Person Name')"
                          :tabindex="2"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <validation-provider
                      #default="{ errors }"
                      :name="t('Country')"
                      rules="required"
                      vid="country_name"
                    >
                      <b-form-group
                        label-for="country_name"
                        :state="errors.length > 0 ? false : null"
                      >
                        <div class="d-flex form-group-label">
                          <label for="name">{{ t('Country') }}</label>
                          <span class="text-danger">*</span>
                        </div>
                        <v-select
                          id="country_name"
                          v-model="values.country_name"
                          :options="countries"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="3"
                          @input="getStateList"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="4">
                    <validation-provider
                      #default="{ errors }"
                      ref="stateValidation"
                      :name="t('City')"
                      rules="required"
                      vid="state_name"
                    >
                      <b-form-group
                        label-for="state_name"
                        :state="errors.length > 0 ? false : null"
                      >
                        <div class="d-flex form-group-label">
                          <label for="name">{{ t('City') }}</label>
                          <span class="text-danger">*</span>
                        </div>
                        <v-select
                          id="state_name"
                          v-model="values.state_name"
                          :options="states"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="4"
                          @input="getCityList"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="4">
                    <validation-provider
                      #default="{ errors }"
                      ref="cityValidation"
                      :name="t('District')"
                      rules="required"
                      vid="city_name"
                    >
                      <b-form-group label-for="city_name" :state="errors.length > 0 ? false : null">
                        <div class="d-flex form-group-label">
                          <label for="name">{{ t('District') }}</label>
                          <span class="text-danger">*</span>
                        </div>
                        <v-select
                          id="city_name"
                          v-model="values.city_name"
                          :options="cities"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="5"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group label-for="email" :label="t('Email')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Email')"
                        rules="required|email"
                      >
                        <b-form-input
                          id="email"
                          v-model="values.email"
                          name="email"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Email')"
                          :tabindex="6"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group label-for="phone_number" :label="t('Phone Number')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Phone Number')"
                        rules="required"
                      >
                        <b-form-input
                          id="phone_number"
                          v-model="values.phone_number"
                          name="phone_number"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Phone Number')"
                          :tabindex="7"
                          autocomplete="off"
                          type="number"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" lg="6">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="postal_code">{{ t('Postal Code') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Postal Code')"
                        rules="required"
                      >
                        <b-form-input
                          id="postal_code"
                          v-model="values.postal_code"
                          name="postal_code"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Postal Code')"
                          tabindex="8"
                          type="number"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" lg="6">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="priority">{{ t('Priority') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Priority')"
                        rules="required"
                      >
                        <b-form-input
                          id="priority"
                          v-model="values.priority"
                          name="priority"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Priority')"
                          tabindex="9"
                          type="number"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="postal_code">{{ t('Address') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Address')"
                        rules="required"
                      >
                        <b-form-textarea
                          id="textarea"
                          v-model="values.address"
                          :placeholder="t('Address')"
                          rows="3"
                          no-resize
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" lg="4">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="name">{{ t('Status') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Status')"
                        rules="required"
                      >
                        <b-form-select
                          id="status"
                          v-model="values.status"
                          name="status"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Status')"
                          tabindex="3"
                          :options="statusOptions"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-button
                      variant="primary"
                      type="button"
                      block
                      class="mt-lg-2"
                      :disabled="submitting"
                      @click="submit"
                    >
                      <feather-icon icon="CheckIcon" size="15" />
                      {{ submitting ? t('Please Wait') : type === 'new' ? t('Add') : t('Edit') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-overlay>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import {
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BRow,
  BFormInvalidFeedback,
  BFormTextarea,
  BFormSelect
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { mapGetters } from 'vuex';
import { helper } from '@core/mixins/helper.js';

export default {
  components: {
    BFormSelect,
    BButton,
    BCard,
    BCardBody,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BRow,
    vSelect,
    BFormInvalidFeedback,
    BFormTextarea,

    ValidationObserver,
    ValidationProvider
  },
  mixins: [helper],
  computed: {
    ...mapGetters({
      countries: 'app/countries',
      states: 'app/consignorStates',
      cities: 'app/consignorCities'
    })
  },
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    defaultGtip: {
      type: Object,
      default: null
    },
    values: {
      type: Object,
      default() {
        return {
          name: '',
          address: '',
          country_id: '',
          state_id: '',
          city_id: '',
          phone_number: '',
          email: '',
          postal_code: '',
          status: true,
          authorized_person_name: '',
          priority: '',
          state_name: '',
          city_name: '',
          country_name: ''
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      statusOptions: []
    };
  },
  mounted() {
    this.statusOptions = [
      { value: 0, text: this.$t('Passive') },
      { value: 1, text: this.$t('Active') }
    ];
  },
  async created() {
    await this.$store.dispatch('app/getCountries');
  },
  methods: {
    getStateList(data) {
      this.values.country_id = this.values.country_name.value;
      this.$refs.stateValidation.reset();
      this.getCityList('');

      if (data && data.value) {
        this.$store.dispatch('app/getConsignorStates', data.value);
      }
    },
    getCityList(data) {
      this.values.state_id = this.values.state_name.value;
      this.values.city_id = data.value;
      this.$refs.cityValidation.reset();

      if (data && data.value) {
        this.$store.dispatch('app/getConsignorCities', {
          countryId: this.values.country_id,
          cityId: this.values.city_id
        });
      }
    },
    submit() {
      this.$refs.detailDepartmentValidate.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            name: this.values.name,
            address: this.values.address,
            phone_number: this.values.phone_number,
            status: this.values.status,
            postal_code: this.values.postal_code,
            authorized_person_name: this.values.authorized_person_name,
            priority: this.values.priority,
            country_id:
              this.type === 'new' ? this.values.country_name.value : this.values.country_id,
            state_id: this.type === 'new' ? this.values.state_name.value : this.values.state_id,
            city_id: this.type === 'new' ? this.values.city_name.value : this.values.city_id,
            email: this.values.email
          });
        }
      });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
